import React from 'react';
import './Class.css';
import class9 from '../../Images/Class-9.png';
import {Helmet} from "react-helmet";
const Class9 = () => (
  <div className="explore-container">
    <Helmet>
                <meta charSet="utf-8" />
                <title>Nauvi ke Sikandar - Otter Tutor</title>
                <link rel="canonical" href="http://ottertutors.com" />
            </Helmet>
    {/* Back Button */}
    <button className="back-button" onClick={() => window.history.back()}>
      ← Back
    </button>
    {/* Lakshya Card (Right Side, Above Header) */}
    <div className="lakshya-card">
      <img
        src={class9} 
        loading="lazy"
        alt="Lakshya NEET 3.0"
        className="lakshya-image"
      />
      <div className="course-details">
  <p className="pricing">💳 Monthly Fees: ₹ 1499/-</p>
  <p className="pricing">💼 Fees Billed Till Exams: ₹ 7499/-</p>
  <a href="https://rzp.io/rzp/nauvikesikandar" target="_blank" rel="noopener noreferrer">
    <button className="buy-button">Buy Now</button>
  </a>
</div>

    </div>

    {/* Lakshya Header (Full Width) */}
    <div className="lakshya-header">
      <div className="lakshya-header-content">
        <h2 className="lakshya-title">Nauvi ke <span className='highlight'>Sikandar</span> (Class-<span className='highlight'>9</span>)</h2>
        
      </div>
    </div>
 {/* Batch Details Section */}
 <div className="batch-details">
      <h3>Description</h3>
      
      <ul>
  <li><strong>1️⃣Small Batches, Big Care</strong>  
    <ul>
      <li>🌱 Only 10 students per batch for personalized attention and growth.</li>
    </ul>
  </li>
  <li><strong>2️⃣Subjects to Master in Class 9</strong>  
    <ul>
      🧮 Mathematics
      🔬 Science
      📖 English
      🌍 Social Science (SST)
      ✍️ Hindi
    </ul>
  </li>
  <li><strong>3️⃣Well-Planned Daily Classes</strong>  
    <ul>
      <li>🕒 Two engaging 1-hour sessions daily led by experienced tutors.</li>
    </ul>
  </li>
  <li><strong>4️⃣24/7 Care for Your Doubts</strong>  
    <ul>
      <li>🩵 We’re here round the clock—ask your questions anytime!</li>
    </ul>
  </li>
  <li><strong>5️⃣Interactive Live Sessions</strong>  
    <ul>
      <li>👩‍🏫 Real-time discussions and activities with passionate educators.</li>
    </ul>
  </li>
  <li><strong>6️⃣Study Resources Tailored for You</strong>  
    <ul>
      <li>📝 Get notes, practice sheets, and recorded lectures to support your learning.</li>
    </ul>
  </li>
  <li><strong>7️⃣Fun & Rewarding Quizzes</strong>  
    <ul>
      <li>🏆 Win prizes and badges in live interactive quizzes to stay motivated!</li>
    </ul>
  </li>
  <li><strong>8️⃣Caring PTMs & Progress Reports</strong>  
    <ul>
      <li>📊 Weekly Parent-Teacher Meetings with detailed performance reviews.</li>
    </ul>
  </li>
  <li><strong>9️⃣Weekly Tests for Excellence</strong>  
    <ul>
      <li>✍️ Stay sharp and confident with regular assessments.</li>
    </ul>
  </li>
  <li><strong>🌈 What Makes Us Special?</strong>  
    <ul>
      <li>💻 Access to a FREE Coding Course to develop 21st-century skills!</li>
    </ul>
  </li>
  <li><strong>📩 We’re Just a Ping Away!</strong>  
    <ul>
      <li>Contact us anytime at <a href="mailto:support@ottertutors.com">support@ottertutors.com</a></li>
    </ul>
  </li>
  <br/>
  <li><strong>❤️ Join <span className='highlight1'>‘Nauvi Ke Sikandar’</span> Embark on a caring, guided journey to excel in Class 9! ❤️</strong>  
    
  </li>
</ul>

    </div>

    {/* FAQ Section */}
    <div className="faq-section">
      <h2>FAQs</h2>
      <p style={{ textAlign: 'center' }}>
  Here are some of the frequently asked questions:
</p>
      <div className="faq-grid">
        <div className="faq-item">
        🎯
          <div>
            <h3>Who Should Join This Batch?</h3>
            <p>
            🎓 Best for Class 9 students who want to excel in their academics and build a strong foundation for future exams.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Where Will the Classes Be Held?</h3>
            <p>💻 Classes will be conducted on Zoom, and the links will be shared in your WhatsApp group.</p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>How Can I Get Help If I Have Doubts?</h3>
            <p>💬 24/7 doubt-solving support is available for students to clarify doubts and get instant solutions.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>What If I Miss a Class?</h3>
            <p>
            📼 All classes are recorded and available for you to review whenever needed.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Are Tests and Quizzes Mandatory?</h3>
            <p>
            ✅ Yes! Weekly tests and live quizzes are part of the curriculum to help track your progress.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Can I Get a Refund After Batch Purchase?</h3>
            <p>
            💡 Refunds are not available after batch purchase due to our investments in quality education. Please make an informed decision.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Class9;
